import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled, CssBaseline } from '@ori-ui/mui';
import throttle from 'lodash.throttle';
import { useState, useEffect, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINT_HORIZONTAL_SIDEPANEL } from '../../constants';
import { configurationContext } from '../../contexts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'newHeight';
  }
})(function (_ref) {
  var _ref$newHeight = _ref.newHeight,
    newHeight = _ref$newHeight === void 0 ? 0 : _ref$newHeight;
  return [{
    '--top-nav-height': "".concat(newHeight, "px")
  }];
});
var TopNav = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    position: 'fixed',
    top: 0,
    left: 0,
    boxSizing: 'border-box',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(0, 3),
    height: 'var(--top-nav-height)',
    display: 'flex',
    boxShadow: "0 0 0 1.5px ".concat(theme.palette.grey[100]),
    transition: "height var(--top-nav-height-animation)"
  };
});
var SideNav = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({}, theme.breakpoints.down(BREAKPOINT_HORIZONTAL_SIDEPANEL), {
    position: 'fixed',
    top: 'var(--top-nav-height)',
    bottom: 0,
    left: 0,
    width: 360
  });
});
var Content = styled('div')(function (_ref5) {
  var theme = _ref5.theme;
  return _defineProperty({
    height: '200vh'
  }, theme.breakpoints.up(BREAKPOINT_HORIZONTAL_SIDEPANEL), {
    maxWidth: theme.spacing(196.8),
    marginRight: 'auto',
    marginLeft: 'auto'
  });
});
var TopNavHeight;
(function (TopNavHeight) {
  TopNavHeight[TopNavHeight["DEFAULT_DESKTOP"] = 80] = "DEFAULT_DESKTOP";
  TopNavHeight[TopNavHeight["DESKTOP_SHRUNK"] = 30] = "DESKTOP_SHRUNK";
  TopNavHeight[TopNavHeight["MOBILE"] = 0] = "MOBILE";
})(TopNavHeight || (TopNavHeight = {}));
var THROTTLE_DELAY = 100;
export var DevelopmentEnvironmentProvider = function DevelopmentEnvironmentProvider(_ref7) {
  var children = _ref7.children;
  var _useState = useState(TopNavHeight.MOBILE),
    _useState2 = _slicedToArray(_useState, 2),
    newHeight = _useState2[0],
    setNewHeight = _useState2[1];
  var isDesktop = useMediaQuery({
    minDeviceWidth: BREAKPOINT_HORIZONTAL_SIDEPANEL
  });
  var _useContext = useContext(configurationContext),
    isDev = _useContext.isDev;
  useEffect(function () {
    setNewHeight(isDesktop ? TopNavHeight.DEFAULT_DESKTOP : TopNavHeight.MOBILE);
    var handleScroll = function handleScroll() {
      var isPageScrolled = window.scrollY > 0;
      var navHeight = 0;
      navHeight = isPageScrolled ? TopNavHeight.DESKTOP_SHRUNK : TopNavHeight.DEFAULT_DESKTOP;
      setNewHeight(navHeight);
    };
    var throttledHandleScroll = throttle(handleScroll, THROTTLE_DELAY);
    window.addEventListener('scroll', throttledHandleScroll);
    return function () {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, [isDesktop]);
  if (!isDev) {
    return children;
  }
  return /*#__PURE__*/_jsxs(Wrapper, {
    newHeight: newHeight,
    children: [/*#__PURE__*/_jsx(CssBaseline, {}), /*#__PURE__*/_jsx(TopNav, {
      children: "TOP NAVIGATION"
    }), /*#__PURE__*/_jsx(SideNav, {
      children: children
    }), /*#__PURE__*/_jsx(Content, {})]
  });
};